import { useCallback, useEffect } from 'react'
import { useLocation } from '@reach/router'
import { useCheckout } from 'src/sdk/checkout/useCheckout'

import {
  buildAwinCustomData,
  buildFacebookCustomData,
  buildTiktokCustomData,
} from './utils/buildCustomData'
import { getAwinParam } from './utils/getAwinParam'
import { getFacebookParams } from './utils/getFacebookParams'
import { findCustomApp } from './utils/findCustomApp'
import { getTiktokParams } from './utils/getTiktokParams'

export function SourceTracker() {
  const { search } = useLocation()
  const { isLoading, addCustomData, orderForm } = useCheckout()

  const dispatchAwinCustomData = useCallback(
    (params: URLSearchParams) => {
      const awcAwinParam = getAwinParam(params)

      addCustomData(buildAwinCustomData(awcAwinParam), true)
    },
    [addCustomData]
  )

  const dispatchTiktokCustomData = useCallback(() => {
    const { ttp } = getTiktokParams()

    addCustomData(buildTiktokCustomData({ ttp }), true)
  }, [addCustomData])

  const dispatchFacebookCustomData = useCallback(() => {
    const { fbc, fbp } = getFacebookParams()

    addCustomData(buildFacebookCustomData({ fbc, fbp }), true)
  }, [addCustomData])

  useEffect(() => {
    const params = new URLSearchParams(search)
    const source = params.get('utm_source')

    if (isLoading) {
      return
    }

    const haveAwinSource = source === 'awin'
    const awinIsAttached = findCustomApp('track-awin', orderForm)

    if (haveAwinSource && !awinIsAttached) {
      dispatchAwinCustomData(params)
    }

    const { fbc, fbp } = getFacebookParams()
    const hasFacebookParams = !!fbc || !!fbp
    const facebookIsAttached = findCustomApp('track-facebook', orderForm)

    if (hasFacebookParams && !facebookIsAttached) {
      dispatchFacebookCustomData()
    }

    const { ttp } = getTiktokParams()
    const hasTiktokParams = !!ttp
    const tiktokIsAttached = findCustomApp('track-tiktok', orderForm)

    if (hasTiktokParams && !tiktokIsAttached) {
      dispatchTiktokCustomData()
    }
  }, [
    search,
    dispatchAwinCustomData,
    dispatchFacebookCustomData,
    dispatchTiktokCustomData,
    isLoading,
    orderForm,
  ])

  return null
}
